export const cibPlex = ["32 32","<path d='M15.527 0h-9.287l10.239 16-10.239 16h9.287l10.233-16-10.233-16z'></path>"]